import { ReactComponent as IconDarkFodler } from '@/assets/svgs/dark-folder.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import useFolders from '@/hooks/use-folder/index'
import rem from '@/utils/rem'
import React from 'react'

export default function RenameFolderModal({ visible, close, data }) {
	const [name, setName] = React.useState(data?.name)
	const [errorMessage, setErrorMessage] = React.useState('')
	const { rename, loading } = useFolders()

	const validateFolderName = (name) => {
		let regex = /^[\w\-\s]+$/
		setErrorMessage(
		regex.test(name)
			? ''
			: 'Please enter allowed characters Alphabetical, Numeric, Hiphen - or Space',
		)
	}

	const handleRenameFolderSubmit = async () => {
		await rename(data?.id, {
			name,
		})
		document.getElementById('reload-eclips')?.click();
		close()
	}

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDarkFodler />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Rename Package Folder
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
					</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-receipient__input">
						<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
							Name of Folder
						</span>
						<input
							type="text" value={name}
							onChange={(e) => {
							setName(e.target.value)
							validateFolderName(e.target.value)
							}}
							maxLength={32}
							placeholder="Name of Folder"
						/>
						{errorMessage && name !== '' && (
							<span className="error error-text">{errorMessage}</span>
						)}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Confirm"
							loading={loading}
							disabled={loading || name === '' || errorMessage !== ''}
							submit={handleRenameFolderSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
